import './scss/main.scss'

import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'

import stores from './stores'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import VueKonva from 'vue-konva'

const app = createApp(App)

app.use(stores)
app.use(router)

// Register VueKonva with explicit configuration
app.use(VueKonva, { prefix: 'V' })

app.use(i18n)
app.use(createVuestic({ config: vuesticGlobalConfig }))

// Debug: Check if components are registered
setTimeout(() => {
  const components = ['VStage', 'VLayer', 'VGroup', 'VImage', 'VRect', 'VText', 'VTransformer']
  components.forEach((name) => {
    if (app.config.globalProperties.$options?.components?.[name] || app._context.components[name]) {
      console.log(`✓ ${name} is registered`)
    } else {
      console.warn(`✗ ${name} is NOT registered`)
    }
  })
}, 1000)

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  )
}

app.mount('#app')
